import {post, get, getFrom} from "@/axios";
//创建包裹异常流程
// export const packTaskPage = function (params) {
//     return post('/wms/packTask/packTaskPage', params)
// }

//组合任务分页
export const getCombinationListApi = function (params) {
    return post('/wms/packTask/packTaskPage', params)
}


//待拣货
export const packAbleTask = function(params){
    return post('/wms/packTask/packAbleTaskPage',params)
}

//批量发起组合
export const createPackBatch = function(params){
    return post('/wms/packTask/createPackBatch',params)
}



//子商品单品调拨分页
export const packAllotPage = function(params){
    return post('/wms/packTask/packAllotPage',params)
}
//创建调拨拣货任务
export const createAllotPick = function(params){
    return post('/wms/packTask/createAllotPick',params)
}
//创建调拨拣货任务_new
export const createAllotPickNew = function(params){
    return post('/wms/packTask/createAllotPickNew',params)
}

//任务列表
export const pickTaskPage = function(params){
    return post('/wms/packTask/pickTaskPage',params)
}
//任务列表_PC
export const pcPickTaskPage = function(params){
    return post('/wms/packTask/pcPickTaskPage',params)
}
//任务列表
export const doPackFinish = function(params){
    return get('/wms/packTask/doPackFinish',params)
}



//质检上架中  查批次包
export const pkgPage = function(params){
    return post('/wms/pkg/pkgPage',params)
}

//查询组合单批次组数上限设置
export const getCombinationPickConfig = function(params){
    return get('/wms/packTask/getCombinationPickConfig',params)
}

//更新组合单批次组数上限设置
export const updateCombinationPickConfig = function(params){
    return post('/wms/packTask/updateCombinationPickConfig',params)
}

//组合分拣框详情
export const getBasketInfo = function(params){
    return get('/wms/packTask/getBasketInfo',params)
}

//查询组合任务分拣框
export const getPackBasket = function(params){
  return get('/wms/packTask/getPackBasket',params)
}

//组合分拣框-拣货商品明细
export const getBasketItem = function(params){
  return get('/wms/packTask/getBasketItem',params)
}

//组合分拣框查询
export const selectPackBasket = function(params){
  return get('/wms/packTask/selectPackBasket',params)
}

//分拣框-组合完成
export const doBasketPackFinish = function(params){
    return post('/wms/packTask/doBasketPackFinish',params)
}







